import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type TroveFeatureCardProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  linkTo: string;
  bgColor?: string;
  textColor?: string;
  buttonColor?: string;
};
const TroveFeatureCard = ({
  title,
  description,
  icon,
  linkTo,
  bgColor = 'bg-indigo-50',
  textColor = 'text-indigo-800',
  buttonColor = 'bg-indigo-600 hover:bg-indigo-700'
}: TroveFeatureCardProps) => {
  return <div className={`rounded-lg ${bgColor} p-6 shadow-sm`} data-id="element-3658" data-mp="2ipn8qmnm3188">
      <div className="flex items-center mb-4" data-id="element-3659" data-mp="2ip3ov0eei2rk">
        <div className="h-12 w-12 rounded-full bg-white flex items-center justify-center mr-4" data-id="element-3660" data-mp="2wpo8tzw1y4mn">
          {icon}
        </div>
        <h3 className={`text-xl font-semibold ${textColor}`} data-id="element-3661" data-mp="2rrd1bvt8c67l">{title}</h3>
      </div>
      <p className="text-gray-600 mb-6" data-id="element-3662" data-mp="12c6kiantp3qk">{description}</p>
      <Link to={linkTo} className={`inline-flex items-center px-4 py-2 ${buttonColor} text-white rounded-md transition-colors`} data-id="element-3663" data-mp="12cyexi5oovf9">
        Explore
        <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-3664" data-mp="21yklwhpewgnt" />
      </Link>
    </div>;
};
export default TroveFeatureCard;